import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { useStringTemplate } from '@blaze-cms/utils-handlebars';
import { HOVER, MOUSE_ENTER, MOUSE_LEAVE, HIDDEN, CLICK } from '../../constants';
import { hasChildren } from '../../helpers';
import BlazeLink from '../BlazeLink';
import MenuContext from '../Menu/MenuContext';
import { injectHelperIntoTemplate, isUrlPathMatch, hasActiveChild } from './helpers';
const MenuItemRender = ({
  children,
  eventType,
  text,
  modifier,
  url,
  parent
}) => {
  const router = useRouter();
  const {
    showMobileMenu,
    openActiveSubmenus
  } = useContext(MenuContext);
  const isHoverEvent = eventType === HOVER;
  const isClickEvent = eventType === CLICK;
  const {
    loading: loadingText,
    data: [textToUse]
  } = useStringTemplate(parent, [text]);
  const {
    loading: loadingUrl,
    data: [urlToUse]
  } = useStringTemplate(parent, [injectHelperIntoTemplate(url, 'url_encode')]);
  const isActive = router ? isUrlPathMatch(router.asPath, urlToUse) : false;
  const isActiveParent = router ? hasActiveChild(router.asPath, children) : false;
  const shouldPreOpen = openActiveSubmenus && isActiveParent && isClickEvent;
  const [displayChildren, setDisplayChildren] = useState(shouldPreOpen);
  useEffect(() => {
    if (!showMobileMenu && !shouldPreOpen) setDisplayChildren(false);
  }, [children, isClickEvent, loadingUrl, openActiveSubmenus, router, shouldPreOpen, showMobileMenu]);
  useEffect(() => {
    if (isHoverEvent) {
      setDisplayChildren(false);
    }
  }, [router.asPath, isHoverEvent]);
  if (loadingUrl || loadingText) return '';
  const childrenDisplayClass = displayChildren ? '' : HIDDEN;
  const handleItemEvent = ({
    type
  }) => {
    if (isHoverEvent) {
      if (type === MOUSE_ENTER) {
        setDisplayChildren(true);
      }
      if (type === MOUSE_LEAVE) {
        setDisplayChildren(false);
      }
    }
  };
  const hasValidChildren = hasChildren(children);
  const menuItemLinkClassname = classnames('menu--item--link', {
    'menu--item--link--active': isActive,
    'menu--item--link--active-parent': isActiveParent
  });
  return /*#__PURE__*/React.createElement("li", {
    className: modifier,
    onMouseEnter: handleItemEvent,
    onMouseLeave: handleItemEvent
  }, /*#__PURE__*/React.createElement("div", {
    className: menuItemLinkClassname
  }, urlToUse ? /*#__PURE__*/React.createElement(BlazeLink, {
    href: urlToUse
  }, textToUse) : /*#__PURE__*/React.createElement("span", {
    role: "button",
    onClick: handleItemEvent
  }, textToUse), hasValidChildren && /*#__PURE__*/React.createElement("i", {
    role: "button",
    className: "menu--item--link--icon",
    onClick: () => setDisplayChildren(!displayChildren)
  }, displayChildren ? /*#__PURE__*/React.createElement(FaChevronUp, null) : /*#__PURE__*/React.createElement(FaChevronDown, null))), hasValidChildren && /*#__PURE__*/React.createElement("div", {
    className: `menu--item-children ${childrenDisplayClass}`
  }, children));
};
MenuItemRender.propTypes = {
  modifier: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
  eventType: PropTypes.string.isRequired,
  parent: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
MenuItemRender.defaultProps = {
  url: '',
  modifier: '',
  text: '',
  children: null,
  parent: {}
};
export default MenuItemRender;
//# sourceMappingURL=MenuItemRender.js.map